export const defaultState = () => {
  return {
    status: {
      import: {
        loading: false,
        success: false,
        error: false
      }
    }
  };
};

const state = defaultState();

export default state;
